export default __webpack_public_path__ + "static/media/closedSign.3821f2d0.png";